import { VersionStatusEnum } from '@onArte/shared/database/enums';

import { PublicProfileVersionDataModel } from './publicProfileVersionData.model';

export class PublicProfileVersionModel {
  public id: string;
  public status: VersionStatusEnum;
  public data: PublicProfileVersionDataModel;
}
